module.exports = __webpack_public_path__ + "img/freshcery.e6f579d0.jpg";